import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useXRInputSourceState } from "@react-three/xr";

/* Thumbstick snap-rotation: push either controller stick left/right to turn 30°. */
export default function SnapTurn({ onTurn, step = Math.PI / 6 }) {
  const right = useXRInputSourceState("controller", "right");
  const left = useXRInputSourceState("controller", "left");
  const armed = useRef(true);

  useFrame(() => {
    const gpR = right?.inputSource?.gamepad;
    const gpL = left?.inputSource?.gamepad;
    const axisOf = (gp) => (gp ? gp.axes?.[2] ?? gp.axes?.[0] ?? 0 : 0);
    const x = Math.abs(axisOf(gpR)) > Math.abs(axisOf(gpL)) ? axisOf(gpR) : axisOf(gpL);

    if (Math.abs(x) > 0.7) {
      if (armed.current) {
        onTurn(x > 0 ? -step : step);
        armed.current = false;
      }
    } else if (Math.abs(x) < 0.3) {
      armed.current = true;
    }
  });

  return null;
}
